import styled from 'styled-components';

const Text = styled.p`
  color: ${({ $color }) => $color || 'var(--content-body)'};

  font-family: ${({ $mono }) => ($mono ? 'var(--font-family-mono)' : 'var(--font-family-body)')};

  font-size: ${({ $small }) => {
    if ($small) return '11px';

    return '13px';
  }};

  line-height: ${({ $small }) => ($small ? 1 : '20px')};
  font-style: normal;
  letter-spacing: -0.02em;
  font-weight: ${({ $bold }) => ($bold ? 600 : 400)};
  margin: 0;
`;

export { Text };
